<div *ngIf="listReport && data" class="wrapper-break-avoid">
	<nz-table #dynamicTable [nzData]="displayReportEntries" [nzFooter]="hasFehlwert || listReport.legend ? footer : null"
		[nzFrontPagination]="false" [nzLoading]="!displayReportEntries" nzTableLayout="auto"
		[nzWidthConfig]="['50%', '80px', '75px', '10%', null]"
		class="kit__utils__table list-report-table">
		<thead>
		<tr>
			<th
				#labelHeader class="label-cell"
				[nz-tooltip]="tooltip"
				[colSpan]="!listReport.header ? 5 : 1"
				[ngClass]="{'text-left': !listReport.header}"
			>
				{{ listReport.title | translate }}
			</th>
			<th *ngIf="listReport.header" class="value-cell" nzAlign="right">{{ listReport.header.labelValue | translate }}</th>
			<th *ngIf="listReport.header" class="unit-cell"></th>
			<th *ngIf="listReport.header"></th>
			<th *ngIf="listReport.header" class="header-label">
				<div class="header-text-left">{{ listReport.header.labelRangeLow | translate }}</div>
				<div class="header-text-right">{{ listReport.header.labelRangeHigh | translate }}</div>
			</th>
		</tr>
		</thead>
		<tbody>
		<ng-template ngFor let-data [ngForOf]="dynamicTable.data">
			<tr *ngIf="data.visible || data.printable" [ngClass]="{
			'print-hide-tr': data.visible && !data.printable,
			'print-only-tr': !data.visible && data.printable}">
				<td #label class="table-cell label-cell" [nz-tooltip]="data.tooltip">{{ data.label }}</td>
				<td nzBreakWord nzAlign="right" class="table-cell value-cell" [ngStyle]="{'color': data.color}">
					{{ data.template }}
				</td>
				<td class="table-cell unit-cell" [ngStyle]="{'color': data.color}">{{ data.unit | translate }}</td>
				<td class="table-cell">
					<div *ngIf="data.fehlwert" class="fehlwert"><span class="fehlwert-value"><workflow-missing-value-icon></workflow-missing-value-icon></span></div>
				</td>
				<td class="table-cell color-bar-cell">
					<div class="left-bar bar-column" *ngIf="data.color">
						<div class="color-bar" [ngStyle]="{'width': (50 - data.range > 0 ? (50 - data.range)*2 : 0) + '%',
						'background': data.color}"></div>
					</div>
					<div class="center-bar bar-column" *ngIf="data.color">
						<div class="color-bar" [ngStyle]="{'background': data.color}"></div>
					</div>
					<div class="right-bar bar-column" *ngIf="data.color">
						<div class="color-bar" [ngStyle]="{'width': (data.range - 50 > 0 ? (data.range - 50)*2 : 0) + '%',
						'background': data.color}"></div>
					</div>
				</td>
			</tr>
		</ng-template>
		</tbody>
	</nz-table>
</div>

<ng-template #footer>
	<div class="footer-label">
		<div>
			<p *ngIf="hasFehlwert" class="fehlwert-value">
				(<span><workflow-missing-value-icon></workflow-missing-value-icon></span>) - {{'word.missing_value' | translate}}
			</p>
		</div>
		<div class="footer-legend">
			<div *ngFor="let color of listReport.legend?.colors">
				<div class="color-block" [ngStyle]="{'background': color.color}"></div>
				<div class="legend-text">{{ color.label | translate }}</div>
			</div>
		</div>
	</div>
</ng-template>
